module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-radius": "16px"
    }
  }, [_c('div', {
    staticClass: "media-list"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("内容专区运营")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.formContent,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专区名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formContent.name),
      callback: function($$v) {
        _vm.$set(_vm.formContent, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formContent.name"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("*名称会显示在硬件设备品牌专区")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专区图片"
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "700px"
    },
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    ref: "uploadxls",
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/aries-api/resource/upload",
      "show-file-list": false,
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUpload,
      "data": _vm.uploadData
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formContent.imgUrl),
      expression: "!formContent.imgUrl"
    }],
    staticClass: "el-icon-upload avatar-uploader-icon"
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.formContent.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text upload__tip",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  })])], 1), _vm._v(" "), (_vm.formContent.imgUrl != '') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-delete"
    },
    on: {
      "click": _vm.delFrontCover
    }
  }, [_vm._v("删除")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "80px"
    },
    attrs: {
      "type": "primary",
      "icon": "arrow-up"
    },
    on: {
      "click": _vm.addContentSection
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "danger",
      "icon": "arrow-up"
    },
    on: {
      "click": _vm.delContentSection
    }
  }, [_vm._v("删除当前内容专区")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "primary",
      "icon": "arrow-up"
    },
    on: {
      "click": _vm.prefecture
    }
  }, [_vm._v("专区分享")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tableList"
  }, [_c('el-form', {
    staticClass: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.formSection,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版块名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formSection.name),
      callback: function($$v) {
        _vm.$set(_vm.formSection, "name", $$v)
      },
      expression: "formSection.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版块ID"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formSection.secId),
      callback: function($$v) {
        _vm.$set(_vm.formSection, "secId", $$v)
      },
      expression: "formSection.secId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "operBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("新建版块")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    attrs: {
      "data": _vm.queryData,
      "header-cell-style": _vm.rowClass,
      "tooltip-effect": "dark",
      "id": "Table"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secId",
      "label": "版块ID",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secName",
      "label": "版块名称",
      "align": "center",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "image",
      "label": "版块图标",
      "align": "center",
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.secIcon,
            "alt": "",
            "width": "220px",
            "height": "72px"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secType",
      "label": "版块类型",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.secType == 1) ? _c('span', [_vm._v("体系课")]) : _vm._e(), _vm._v(" "), (scope.row.secType == 2) ? _c('span', [_vm._v("特色课程")]) : _vm._e(), _vm._v(" "), (scope.row.secType == 3) ? _c('span', [_vm._v("音频资源")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateAt",
      "label": "更新时间",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate2")(scope.row.updateAt)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("未上架")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "编辑",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.step == 0) ? _c('el-dialog', {
    attrs: {
      "title": "分享运营内容",
      "visible": _vm.dialogVisible,
      "width": "60%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "125px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*邀请码类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.valueTo),
      callback: function($$v) {
        _vm.$set(_vm.form, "valueTo", $$v)
      },
      expression: "form.valueTo"
    }
  }, _vm._l((_vm.InvitationCode), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.form.valueTo == 1 ? '人数' : '*SN数量'
    }
  }, [(_vm.form.valueTo == 1) ? _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.peopleNumTo),
      callback: function($$v) {
        _vm.$set(_vm.form, "peopleNumTo", $$v)
      },
      expression: "form.peopleNumTo"
    }
  }, _vm._l((_vm.peopleNum), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.form.valueTo != 1) ? _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.peopleNumToSelf),
      callback: function($$v) {
        _vm.$set(_vm.form, "peopleNumToSelf", $$v)
      },
      expression: "form.peopleNumToSelf"
    }
  }, _vm._l((_vm.peopleNumSelf), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.form.valueTo == 1 ? '使用时限' : '*兑换时限'
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "180px",
      "font-size": "10px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.startTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "startTime", $$v)
      },
      expression: "form.startTime"
    }
  }), _vm._v("\n          至\n          "), _c('el-date-picker', {
    staticStyle: {
      "width": "180px",
      "font-size": "10px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "margin-left": "80px"
    }
  }, [_vm._v("*听力熊T3，T4系列不支持多层专辑显示")])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#009e7d",
      "color": "#ffffff",
      "margin-bottom": "20px"
    },
    on: {
      "click": _vm.creatInvitation
    }
  }, [_vm._v("\n        " + _vm._s(_vm.form.valueTo == 1 ? "创建邀请码" : "创建专享码") + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right",
      "margin-top": "-40px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('el-dialog', {
    attrs: {
      "title": "创建成功",
      "visible": _vm.dialogVisible,
      "width": "60%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.typeValueTo == 1) ? _c('el-form', {
    attrs: {
      "model": _vm.formNext,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邀请码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.formNext.Invitation),
      callback: function($$v) {
        _vm.$set(_vm.formNext, "Invitation", $$v)
      },
      expression: "formNext.Invitation"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.typeValueTo != 1) ? _c('p', [_vm._v("创建了" + _vm._s(_vm.numPeopleTo) + "个专项码")]) : _vm._e(), _vm._v(" "), (_vm.typeValueTo == 1) ? _c('el-button', {
    staticStyle: {
      "background-color": "#009e7d",
      "color": "#ffffff",
      "margin-bottom": "20px",
      "margin-top": "20px"
    },
    on: {
      "click": _vm.copyInvitation
    }
  }, [_vm._v("\n        复制邀请码\n      ")]) : _vm._e(), _vm._v(" "), (_vm.typeValueTo != 1) ? _c('el-button', {
    staticStyle: {
      "background-color": "#009e7d",
      "color": "#ffffff",
      "margin-bottom": "20px",
      "margin-top": "20px"
    },
    on: {
      "click": _vm.checkInvitation
    }
  }, [_vm._v("\n        查看\n      ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right",
      "margin-top": "-40px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "padding": "10px 20px",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "bottomOperBtn"
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "danger",
      "icon": "delete2"
    },
    on: {
      "click": _vm.delSection
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary",
      "icon": "arrow-up"
    },
    on: {
      "click": _vm.commitSection
    }
  }, [_vm._v("上架")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "info",
      "icon": "arrow-down"
    },
    on: {
      "click": _vm.downSection
    }
  }, [_vm._v("下架")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.dodisabled,
      "icon": "arrow-up"
    },
    on: {
      "click": _vm.handleShare
    }
  }, [_vm._v("版块分享")])], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.dodisabled,
      "icon": "arrow-up"
    },
    on: {
      "click": _vm.shareRecord
    }
  }, [_vm._v("分享记录")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pagination-box",
    staticStyle: {
      "padding": "0px 0px 30px 0px !important"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733f4436","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/contentSection.vue
// module id = 710
// module chunks = 1